module.exports = __webpack_public_path__ + "static/img/税务筹划_内训版.64a3453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/税务筹划_内训版.jpg
// module id = xVJU
// module chunks = 1